//토모플레이 - 본사 - 지사별 사용량 - 리스트
import React, { Component } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";
import playStyle from "../components/style";

export default class BranchContentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryList: null,
            data: null,
            tableData: null,
            keyword: null,

        };
        this.searchRef = React.createRef();
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(
            {
                data: nextProps.data,
            },
            () => {
                this.setState({ tableData: this.listSearch(this.state.keyword), categoryList: this.props.categoryList });
            }
        );
    };

    defaultColDef = {
        editable: false,
        sortable: true,
        minWidth: 50,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
        suppressMovable: true,
    };

    listColumn = [
        {
            headerName: "No",
            field: "id",
            minWidth: 45,
            width: 80,
            sortable: false,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "지사",
            field: "branchName",
            width: 200,
            minWidth: 100,
            cellClass: "text-left",
        },
        {
            headerName: "전체 콘텐츠",
            field: "total",
            minWidth: 100,
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];
    listColumn = this.listColumn.concat(
        playStyle.seriesPlayChart.map((lc) => {
            return {
                headerComponentParams: {
                    template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">${lc.name}<br/> 실행 수</div></div>`,
                },
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                field: `${lc.field}`,
                minWidth: 80,
                resizable: true,
                filter: false,
                cellRenderer: (param) => {
                    return param.value ? param.value.toLocaleString() : "-";
                },
            };
        })
    );

    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.searchData();
        }
    };

    searchData = () => {
        if (this.searchRef.current) {
            var keyword = this.searchRef.current.value;

            var tableData = this.listSearch(keyword);

            this.setState({
                tableData: tableData,
                keyword: keyword,
            });
        }
    };

    listSearch = (keyword) => {
        var list = this.state.data;
        var tableData = [];
        if (!keyword) {
            tableData = list;
        } else {
            if (list && list.length > 0) {
                list.map((item) => {
                    if (item.nurseryName && item.nurseryName.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                    if (item.menu && item.menu.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                    if (item.category && item.category.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                });
            }
        }
        return tableData;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
    };

    rowClick = (agGrid) => {
        const selected = agGrid.api.selectionController.lastSelectedNode.data;
        if (selected && this.props.onRowClick) {
            this.props.onRowClick(selected.nurseryUniqId, selected.nurseryName);
        }
    };

    rowDataChanged = (parmas) => {
        this.setState({
            tableSummary: (this.state.tableData ? this.state.tableData.length.toLocaleString() : 0) + " / " + (this.state.data ? this.state.data.length.toLocaleString() : 0),
        });
    };

    onSortChanged = (params) => {
        const sortState = params.api.getSortModel();
        if (sortState.length == 0) {
            this.props.onListSortChanged(null, null);
        } else {
            if (this.props.onListSortChanged) {
                this.props.onListSortChanged(sortState[0].colId, sortState[0].sort);
            }
        }
    };

    render() {
        if (this.state.tableData == null) {
            return (
                <>
                    <div
                        style={{
                            height: this.props.height + "px",
                            textAlign: "center",
                            paddingTop: `${this.props.height / 2 - 80}px`,
                        }}
                    >
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="row justify-content-end">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-4 d-flex">
                            <h5 className="mb-0" style={{ alignSelf: "end" }}>
                                <span>
                                    {this.state.tableData ? this.state.tableData.length.toLocaleString() : "0"} / {this.state.data ? this.state.data.length.toLocaleString() : "0"}
                                </span>
                            </h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                defaultColDef={this.defaultColDef}
                                columnDefs={this.listColumn}
                                height={600}
                                headerHeight={40}
                                rowData={this.state.tableData}
                                onGridReady={this.onGridReady}
                                onRowDataChanged={this.rowDataChanged}
                                onSortChanged={this.onSortChanged}
                                rowSelection="single"
                                onSelectionChanged={this.rowClick}
                                pagination={true}
                            />
                        </div>
                    </div>
                </>
            );
        }
    }
}
